import { render, staticRenderFns } from "./CanceledSales.vue?vue&type=template&id=8d0f14e8"
import script from "./CanceledSales.vue?vue&type=script&lang=js"
export * from "./CanceledSales.vue?vue&type=script&lang=js"
import style0 from "./CanceledSales.vue?vue&type=style&index=0&id=8d0f14e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports